import React, { useState, useEffect } from "react";
import { Steps as AntSteps } from "antd";
import "./Steps.css";

export const Steps = ({ size = "default", current = 0, children, ...props }) => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1000);
  const validSize = size === "small" ? "small" : "default";
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get step titles from children
  const steps = React.Children.toArray(children);
  const currentStep = steps[current];
  const currentStepTitle = currentStep && 
    React.isValidElement(currentStep) && 
    currentStep.props && 
    typeof currentStep.props === 'object' && 
    'title' in currentStep.props
    ? String(currentStep.props.title)
    : `Step ${current + 1}`;
  
  // Show counter for screens smaller than 600px
  if (windowWidth < 600) {
    return (
      <div className="custom-steps-mobile">
        <div className="steps-counter">
          <span className="progress-dots">
            {Array.from({ length: steps.length }, (_, index) => (
              <span 
                key={index} 
                className={`dot ${index === current ? 'active' : ''} ${index < current ? 'completed' : ''}`}
              >
                ●
              </span>
            ))}
          </span>
          <span className="counter-title">{currentStepTitle}</span>
        </div>
      </div>
    );
  }
  
  // Show full steps for larger screens
  return (
    <div className="custom-steps-wrapper">
      <AntSteps size={validSize} current={current} {...props}>
        {children}
      </AntSteps>
    </div>
  );
};

// Use the actual Ant Design Step component
export const Step = AntSteps.Step;

Steps.Step = Step;
